import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { ConfirmDialogueComponent } from './comp/confirm-dialogue/confirm-dialogue.component';
import { ButtonComponent } from './comp/dynamic-form/button-component/button-component.component';
import { CheckboxComponent } from './comp/dynamic-form/checkbox-component/checkbox-component.component';
import { DateComponent } from './comp/dynamic-form/date-component/date-component.component';
import { DynamicFieldDirective } from './comp/dynamic-form/dynamic-field.directive';
import { DynamicFormComponent } from './comp/dynamic-form/dynamic-form/dynamic-form.component';
import { FileUploadComponent } from './comp/dynamic-form/file-upload-component/file-upload-component.component';
import { InputComponent } from './comp/dynamic-form/input-component/input-component.component';
import { RadiobuttonComponent } from './comp/dynamic-form/radiobutton-component/radiobutton-component.component';
import { SelectComponent } from './comp/dynamic-form/select-component/select-component.component';
import { GidSelectComponent } from './comp/gid-select/gid-select.component';
import { GeneralResponseComponent } from './comp/general-response/general-response.component';
import { ReportConfigContainerComponent } from './comp/report-config/report-config-container.component';
import { ReportConfigComponent } from './comp/report-config/report-config.component';
import { ReportDefinitionTableComponent } from './comp/report-config/report-definition-table.component';
import { ReportGroupComponent } from './comp/report-config/report-group.component';
import { ReportHistoryTableComponent } from './comp/report-config/report-history-table.component';
import { ReportScheduleContainerComponent } from './comp/report-config/report-schedule-container.component';
import { ReportScheduleTableComponent } from './comp/report-config/report-schedule-table.component';
import { ReportScheduleComponent } from './comp/report-config/report-schedule.component';
import { ReportTemplateComponent } from './comp/report-config/report-template.component';
import { SendNotificationComponent } from './comp/send-notification/send-notification.component';
import { UserPortalSelectComponent } from './comp/user-portal-select/user-portal-select.component';
import { CustomErrorStateMatcher } from './custom-error-state-matcher';
import { Environment } from './model/environment';
import { SortFilter } from './model/sort-filter';
import { AuthService } from './services/auth.service';
import { Auth0ApplicationService } from './services/auth0-application.service';
import { Auth0ConnectionService } from './services/auth0-connection.service';
import { Auth0PermissionsService } from './services/auth0-permissions.service';
import { Auth0ResourceService } from './services/auth0-resource.service';
import { Auth0TenantService } from './services/auth0-tenant.service';
import { AutoLogoutService } from './services/auto-logout.service';
import { ConfigService } from './services/config.service';
import { ErrorService } from './services/error.service';
import { LoggingService} from './services/logging.service';
import { MultiFactorService } from './services/multifactor.service';
import { NotificationService } from './services/notification.service';
import { PortalRegisterService } from './services/portal-register.service';
import { ReportService } from './services/report.service';
import { RequestCacheService } from './services/request-cache.service';
import { ScopeGuardService } from './services/scope-guard.service';
import { ServicePointService } from './services/service-point.service';
import { UserAccessControlService } from './services/user-access-control.service';
import { UserDeviceService } from './services/user-device.service';
import { UserService } from './services/user.service';
// import { AuthGuard } from './services/auth-guard.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserProfileService } from './services/user-profile.service';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { MatCardModule } from '@angular/material/card';
import { RtcService } from './services/rtc.service';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    // AngularMultiSelectModule,
    // NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatExpansionModule,
    DragDropModule,
    MatDialogModule,
    MatIconModule,
    MatCheckboxModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSortModule,
    MatInputModule,
    MatButtonModule,
    // Added                                        08/05/2024 RL
    MatCardModule,
    // Reusable notify banner 20/07/2026 DW
    GeneralResponseComponent,
  ],
  providers: [
    // AuthService omitted: use root singleton (providedIn: 'root') so lazy modules share same instance. 06/02/2026 TK
    ScopeGuardService,
    SortFilter,
    RequestCacheService,
    ErrorService,
    LoggingService,
    CustomErrorStateMatcher,
    UserProfileService,
    RtcService
  ],
  exports: [
    GidSelectComponent,
    GeneralResponseComponent,
    DynamicFormComponent,
    ConfirmDialogueComponent,
    ReportDefinitionTableComponent,
    ReportGroupComponent,
    ReportTemplateComponent,
    ReportScheduleTableComponent
  ],
  declarations: [
    GidSelectComponent,
    UserPortalSelectComponent,
    DynamicFormComponent,
    DynamicFieldDirective,
    InputComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    FileUploadComponent,
    ReportConfigComponent,
    ReportDefinitionTableComponent,
    ReportConfigContainerComponent,
    ReportGroupComponent,
    ReportTemplateComponent,
    ReportScheduleTableComponent,
    ReportScheduleContainerComponent,
    ReportScheduleComponent,
    ReportHistoryTableComponent,
    ConfirmDialogueComponent,
    SendNotificationComponent,
  ],
})
export class ServicesModule {
  static forRoot(config: Environment): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        // AuthService omitted: use root singleton so userProfile is shared after login. 06/02/2026 TK
        {
          provide: ConfigService,
          useValue: config,
        },
        ScopeGuardService,
        AutoLogoutService,
        {
          provide: ConfigService,
          useValue: config,
        },
        PortalRegisterService,
        {
          provide: ConfigService,
          useValue: config,
        },
        UserService,
        {
          provide: ConfigService,
          useValue: config,
        },
        ServicePointService,
        {
          provide: ConfigService,
          useValue: config,
        },
        UserAccessControlService,
        {
          provide: ConfigService,
          useValue: config,
        },
        MultiFactorService,
        {
          provide: ConfigService,
          useValue: config,
        },
        Auth0TenantService,
        {
          provide: ConfigService,
          useValue: config,
        },
        Auth0ApplicationService,
        {
          provide: ConfigService,
          useValue: config,
        },
        Auth0ResourceService,
        {
          provide: ConfigService,
          useValue: config,
        },
        Auth0ConnectionService,
        {
          provide: ConfigService,
          useValue: config,
        },
        Auth0PermissionsService,
        {
          provide: ConfigService,
          useValue: config,
        },
        UserDeviceService,
        {
          provide: ConfigService,
          useValue: config,
        },
        NotificationService,
        {
          provide: ConfigService,
          useValue: config,
        },
        LoggingService,
        ReportService,
        {
          provide: ConfigService,
          useValue: config,
        },
        UserProfileService,
      ],
    };
  }
}
